import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pl from 'vuetify/es5/locale/pl';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pl },
    current: 'pl',
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        accent: '#891232',
        'accent-light': '#c77a82',
      },
      dark: {
        // primary: '#671821',
        // secondary: '#671821',
        accent: '#671821',
        'accent-light': '#c77a82',
        // error: '#671821',
      },
    },
  },
});
